import React from 'react';
import { UnitListFragment } from '../../../generated/graphql';
import { IconButton, Stack, Typography } from '@mui/material';

import { RemoveItemIcon } from '../../../components/icons';
interface UnitListProps {
  units: UnitListFragment[];
  onRemove?: (unit: UnitListFragment) => void;
  onClick?: (unit: UnitListFragment) => void;
  disabled?: boolean;
}

export function UnitList(props: UnitListProps) {
  const { units: units, onRemove, onClick, disabled } = props;
  return (
    <Stack spacing={0} width="100%">
      {units.length === 0 && <p>Žiadne nehnuteľnosti nie sú zahrnuté v prenájme.</p>}
      {units.map((p) => {
        return (
          <Stack key={p.id} direction="row" alignItems="center">
            <IconButton onClick={() => onRemove && onRemove(p)} disabled={disabled}>
              <RemoveItemIcon />
            </IconButton>
            <Typography variant="body1" sx={{ flexGrow: 1 }} onClick={() => onClick && onClick(p)}>
              {p.name}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
}
